<template>
    <div class="card shadow-sm mb-4">
        <div class="card-header text-white bg-secondary fw-bold">Pending Visits</div>
        <div class="card-content p-2">
            <div v-if="!visit_loading">
                <span v-if="Object.keys(props.pending_visits).length">
                    <a :href="'/#/request/' + pending.id" v-for="pending in props.pending_visits" v-bind:key="pending.id" class="col-12 d-block visit-card-anchor" @click="router.push({name:'request',params:{request_id:pending.id}})">
                        <div class="row visit-card">
                            <div class="col-10">
                                <img :src="pending.scenario.patient_image.location" class="rounded-circle float-start me-2" width="75" />
                                <div class="fw-bold text-secondary">{{pending.scenario.patient_name}}</div>
                                <div class="overflow-hidden">
                                    <span>{{pending.scenario.title}}</span>
                                    <br>
                                    <span v-for="(date, index) in pending.dates" v-bind:key="date.id" class="visit-dates">
                                        <span class="text-secondary">{{ moment(date.local_time).format('MM/DD/YY') }}</span>&nbsp;<span class="text-primary">{{ moment(date.local_time).format('h:mma') }}</span><span class="font-italic" v-if="index==0"> or </span>
                                    </span>
                                    <br>
                                    <div v-if="is_admin">
                                        <span class="mt-3 text-secondary"><small>{{pending.partner.slug}}</small></span>
                                        <br>
                                        <span><small><span class="text-secondary">Participant</span><br> {{pending.user.name}} ({{pending.user.email}})</small></span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-2 d-flex flex-column justify-content-center">
                                <h3 class="text-center"><i class='far fa-calendar-alt text-primary'></i></h3>
                            </div>
                        </div>
                        <hr class="w-75" />
                    </a>
                    <lazy-pagination v-if="pending_visits_total > 10" :items="props.pending_visits" :total="props.pending_visits_total" :page_start="page_start" :page_end="page_end" v-on:next-page="nextPage" v-on:previous-page="previousPage" :label="'Requests'" />
                </span>
                <p v-else class="text-center pt-3">No Pending Visits</p>
            </div>
            <div class="loading-card-area" v-else>
                <loading :active="visit_loading" :is-full-page="false"></loading>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import {defineComponent,ref} from "vue";
    import Loading from 'vue3-loading-overlay';
    import moment from 'moment';
    import LazyPagination from '@/components/dashboard/lazy-pagination.vue';
    import router from "@/router";

    export default defineComponent({
        emits: ['change-page'],
        components: {
            Loading,
            LazyPagination
        },
        props: {
            reset_pagination: {type:Boolean, default: false},
            pending_visits: {type:Object, required:true},
            pending_visits_total: {type:Number, required:true},
            visit_loading: {type:Boolean, required:true},
            is_admin: {type:Boolean, default:false}
        },
        watch: {
            reset_pagination: function(reset){
                if(reset){
                    this.page_start = 0;
                    this.page_end = 10;
                }
            },
        },
        setup(props, {emit}) {
            const page_start = ref(0);
            const page_end = ref(10);
            const nextPage = async() => {
                page_start.value = page_start.value + 10;
                page_end.value = page_end.value + 10;
                if(page_end.value > props.pending_visits_total){
                    page_end.value = props.pending_visits_total;
                }
                emit('change-page',{type:'requests','page_start':page_start.value});
            };
            const previousPage = async() => {
                page_start.value = page_start.value - 10;
                page_end.value = page_start.value + 10;
                emit('change-page',{type:'requests','page_start':page_start.value});
            };
            return {
                moment,
                nextPage,
                page_end,
                page_start,
                previousPage,
                props,
                router
            };
        }
    });
</script>
